'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFavoriteOutline = function MdFavoriteOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.2 30.9q3.7-3.3 5.5-5t3.9-4.1 2.9-4.1 0.9-3.6q0-2.5-1.7-4.1t-4.2-1.6q-2 0-3.6 1.1t-2.3 2.8h-3.2q-0.6-1.7-2.3-2.8t-3.6-1.1q-2.5 0-4.2 1.6t-1.7 4.1q0 1.8 0.9 3.6t2.9 4.1 3.9 4.1 5.5 5l0.2 0.2z m7.3-25.9q3.9 0 6.5 2.7t2.6 6.4q0 2.3-0.8 4.5t-3.2 4.8-4.2 4.4-6 5.6l-2.4 2.1-2.4-2.1q-5.4-4.8-7.8-7.2t-4.4-5.7-2-6.4q0-3.8 2.6-6.4t6.5-2.7q4.5 0 7.5 3.5 3-3.5 7.5-3.5z' })
        )
    );
};

exports.default = MdFavoriteOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/favorite-outline.js
// module id = 2820
// module chunks = 0